module.exports = __webpack_public_path__ + "static/media/mw-image.92039461.PNG";